module.exports = __webpack_public_path__ + "media/86.1a87bd55.mp3";